module.exports = __webpack_public_path__ + "img/bitrix-product.e1765912.png";